<!-- =========================================================================================
  File Name: Showcases.vue
  Description: Showcases' list
  ----------------------------------------------------------------------------------------
  Item Name: FastWay - Showcases list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>

  <div>
<!--    <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-plus" class="add-button" :to="{name: 'showcase', params: { id: 0 }}"/>-->

    <div class="p-6 flex flex-row">
      <div
        class="vx-card flex w-full mb-4 bg-contain bg-no-repeat bg-center cursor-pointer mx-2 p-3 relative overflow-hidden"
        :style="{ 'background-image': `url(${image(item)})`}"
        style="background-repeat: no-repeat; background-position: center center; height: 400px;"
        @click="edit(item)"
        v-for="item in data" :key="item.id">
        <div class="absolute bg-danger px-10 py-2 text-white text-bold text-center" style="width: 200px; top: 20px; right: -60px; transform: rotate(45deg);" v-show="item.statusId != 'ACT'"><b>INACTIVO<br/></b></div>
        <div class="w-full items-center">
          <span class="text-2xl"><b>{{ item.sequence }}</b></span>
          <span class="text-lg"> = {{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        loaded: false
      }
    },
    computed: {
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      data() {
        return [...this.$store.getters.showcaseList].sort(function (a, b) {
          let ret = 1;
          if (a.sequence < b.sequence) {
            ret = -1;
          }
          return ret;
        });
      }
    },
    methods: {
      image(item) {
        const image = item.imageURL.split('.');
        return [this.imagesURL, '/showcase%2F', image[0], '@400.', image[1], '?alt=media'].join('');
      },
      edit(item) {
        this.$router.push(`/home/showcase/${item.id}`).catch(() => { });
      }
    }
  }

</script>

<style lang="scss">
  .add-button {
    position: fixed;
    bottom: 5%;
    right: 29px;
    z-index: 51000;
    box-shadow: 0 1px 20px 1px rgb(251, 67, 79);
  }
</style>
